import React from 'react'

import { Box, Button, Icon, Text } from '@factorialco/deprecated-design-system'
import { AvailableModules, Features } from 'generated/featureDefinitions'

import i18n from 'modules/core/lib/i18n'

import RequestUpgradeModal from 'modules/upsell/components/RequestUpgradeModal'
import useCreateUpsellRequest, { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'

import { ProjectsUpsellRequestSources } from '../constants'
import { useCreateUpsellNotificationMessage } from '../hooks/useCreateUpsellNotificationMessage'

interface UpsellProjectSpendingMessageProps {
  hasCost: boolean
  hasExpenses: boolean
}

export const UpsellProjectSpendingMessage = ({
  hasCost,
  hasExpenses,
}: UpsellProjectSpendingMessageProps) => {
  const [upsellRequested, setUpsellRequested] = React.useState(false)
  const { create: createUpsellRequest } = useCreateUpsellRequest()
  const { sendUpsellNotificationMessage } = useCreateUpsellNotificationMessage()

  const upsellMessage = hasCost
    ? i18n.t('project_management.spending.table.upsell_message.no_legacy_plan')
    : i18n.t('project_management.spending.table.upsell_message.legacy_plan')

  const sendUpsellNotificationAndRequestProjectsUpsell = () => {
    sendUpsellNotificationMessage(ProjectsUpsellRequestSources.spending)

    if (!hasCost && !hasExpenses) {
      createUpsellRequest({
        moduleRequested: AvailableModules.projects,
        featureRequested: Features.projects_costs,
        requestSource: ProjectsUpsellRequestSources.spending.toString(),
        requestReason: hasCost ? ValidReasons.MissingFeature : ValidReasons.UpgradeFromLegacy,
      })
    }
  }

  return (
    <Box alignItems="center" textAlign="center" gap="s8" paddingX="s200">
      <Icon.Large icon="fireworks" />
      <Text weight="medium" size="300" color="grey1000">
        {i18n.t('packaging.upgrade_plan.title')}
      </Text>
      <Box alignItems="center" gap="s16">
        <Text size="300" color="grey800">
          {upsellMessage}
        </Text>
        <Button aria-label="Click me" onClick={() => setUpsellRequested(true)} type="upgrade">
          {i18n.t('common.contact_support')}
        </Button>
      </Box>
      {upsellRequested &&
        (!hasCost && hasExpenses ? (
          <RequestUpgradeModal
            moduleRequested={AvailableModules.projects}
            featureRequested={Features.projects_costs}
            requestReason={hasCost ? ValidReasons.MissingFeature : ValidReasons.UpgradeFromLegacy}
            onClose={() => setUpsellRequested(false)}
            onSuccess={() => sendUpsellNotificationMessage(ProjectsUpsellRequestSources.spending)}
          />
        ) : (
          <RequestUpgradeModal
            moduleRequested={AvailableModules.expenses}
            requestReason={ValidReasons.MissingAddon}
            onClose={() => setUpsellRequested(false)}
            onSuccess={() => sendUpsellNotificationAndRequestProjectsUpsell()}
          />
        ))}
    </Box>
  )
}
